<template>
  <ion-app>
    <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
    <ion-content>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="onboarding-header">
          <div class="progress-indicator mb-3">
            <span style="width: 75%"></span>
          </div>
          <p class="mt-0 mb-1 ion-text-uppercase dark text-sm d-flex-align-center">
            <ion-icon name="arrow-dropleft-circle" class="mr-1 cursor-pointer" @click="gotoBack"></ion-icon>Passo 3 de 4
          </p>
          <p class="mt-0 mb-0 white text-xxl ion-text-uppercase">Alergias &amp; Restrições</p>
        </div>
        <div class="onboarding-row-pt pb-4">
          <label class="dark bold">Você tem alguma restrição alimentar?</label>
          <div class="mb-5 mt-2">
            <div class="mb-2 mt-4" @click="selectRestriction('vegan')">
              <div :class="restrictionsVegan.class">
                <p class="mt-0 mb-0 text-left text-md bold">Vegano</p>
                <div v-if="restrictionsVegan.selected" class="selected-icon">
                  <ion-icon mode="ios" name="checkmark-circle" size="large" class="green"></ion-icon>
                </div>
              </div>
            </div>
            <div class="mb-2" @click="selectRestriction('vegetarian')">
              <div :class="restrictionsVegetarian.class">
                <p class="mt-0 mb-0 text-left text-md bold">Vegetariano</p>
                <div v-if="restrictionsVegetarian.selected" class="selected-icon">
                  <ion-icon mode="ios" name="checkmark-circle" size="large" class="green"></ion-icon>
                </div>
              </div>
            </div>
            <div class="mb-2" @click="selectRestriction('meatFreeMonday')">
              <div :class="restrictionsMeatFreeMonday.class">
                <p class="mt-0 mb-0 text-left text-md bold">Segunda-feira sem carne</p>
                <div v-if="restrictionsMeatFreeMonday.selected" class="selected-icon">
                  <ion-icon mode="ios" name="checkmark-circle" size="large" class="green"></ion-icon>
                </div>
              </div>
            </div>
            <div class="mb-2" @click="selectRestriction('lactoseFree')">
              <div :class="restrictionsLactoseFree.class">
                <p class="mt-0 mb-0 text-left text-md bold">Sem lactose</p>
                <div v-if="restrictionsLactoseFree.selected" class="selected-icon">
                  <ion-icon mode="ios" name="checkmark-circle" size="large" class="green"></ion-icon>
                </div>
              </div>
            </div>
            <div class="mb-2" @click="selectRestriction('glutenFree')">
              <div :class="restrictionsGlutenFree.class">
                <p class="mt-0 mb-0 text-left text-md bold">Sem glúten</p>
                <div v-if="restrictionsGlutenFree.selected" class="selected-icon">
                  <ion-icon mode="ios" name="checkmark-circle" size="large" class="green"></ion-icon>
                </div>
              </div>
            </div>
          </div>
          <label class="dark bold">Você é alérgico a algum destes componentes?</label>
          <div class="mb-4 mt-3">
            <ion-row>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('gluten')">
                  <div :class="allergiesGluten.class">
                    <p class="mt-0 mb-0 text-sm bold">Glúten</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('crustaceans')">
                  <div :class="allergiesCrustaceans.class">
                    <p class="mt-0 mb-0 text-sm bold">Crustáceos</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('eggs')">
                  <div :class="allergiesEggs.class">
                    <p class="mt-0 mb-0 text-sm bold">Ovo</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('fish')">
                  <div :class="allergiesFish.class">
                    <p class="mt-0 mb-0 text-sm bold">Peixe</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('peanuts')">
                  <div :class="allergiesPeanuts.class">
                    <p class="mt-0 mb-0 text-sm bold">Amendoim</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('soya')">
                  <div :class="allergiesSoya.class">
                    <p class="mt-0 mb-0 text-sm bold">Soja</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('milk')">
                  <div :class="allergiesMilk.class">
                    <p class="mt-0 mb-0 text-sm bold">Leite</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('nuts')">
                  <div :class="allergiesNuts.class">
                    <p class="mt-0 mb-0 text-sm bold">Nozes</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('celery')">
                  <div :class="allergiesCelery.class">
                    <p class="mt-0 mb-0 text-sm bold">Salsão</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('mustard')">
                  <div :class="allergiesMustard.class">
                    <p class="mt-0 mb-0 text-sm bold">Mostarda</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('sesame')">
                  <div :class="allergiesSesame.class">
                    <p class="mt-0 mb-0 text-sm bold">Gergelim</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('sulphites')">
                  <div :class="allergiesSulphites.class">
                    <p class="mt-0 mb-0 text-sm bold">Sulfitos</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('lupin')">
                  <div :class="allergiesLupin.class">
                    <p class="mt-0 mb-0 text-sm bold">Lúpulo</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-2 mr-1 ml-1" @click="selectAllergy('molluscs')">
                  <div :class="allergiesMolluscs.class">
                    <p class="mt-0 mb-0 text-sm bold">Moluscos</p>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </div>
          <ion-button expand="block" mode="ios" shape="round" class="main-button" @click="gotoNext">
            <ion-icon mode="ios" name="arrow-forward" class="white"></ion-icon>
          </ion-button>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// component
export default {
  name: "OnboardingRestrictions",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: false,
      fullPage: true,
      user: store.state.user,
      profile: store.state.profile,
      allergies: [],
      allergiesGluten: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesCrustaceans: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesEggs: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesFish: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesPeanuts: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesSoya: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesMilk: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesNuts: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesCelery: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesMustard: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesSesame: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesSulphites: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesLupin: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      allergiesMolluscs: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      restrictions: [],
      restrictionsVegan: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-4"
      },
      restrictionsVegetarian: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-4"
      },
      restrictionsMeatFreeMonday: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-4"
      },
      restrictionsLactoseFree: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-4"
      },
      restrictionsGlutenFree: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-4"
      }
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoBack() {
      this.$router.go(-1);
    },
    selectAllergy(allergy) {
      const allergies = this.allergies;
      if (allergies.includes(allergy)) {
        for (let i = 0; i < allergies.length; i++) {
          if (allergies[i] === allergy) {
            allergies.splice(i, 1);
          }
        }
        if (allergy === "gluten") {
          this.allergiesGluten = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "crustaceans") {
          this.allergiesCrustaceans = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "eggs") {
          this.allergiesEggs = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "fish") {
          this.allergiesFish = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "peanuts") {
          this.allergiesPeanuts = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "soya") {
          this.allergiesSoya = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "milk") {
          this.allergiesMilk = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "nuts") {
          this.allergiesNuts = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "celery") {
          this.allergiesCelery = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "mustard") {
          this.allergiesMustard = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "sesame") {
          this.allergiesSesame = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "sulphites") {
          this.allergiesSulphites = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "lupin") {
          this.allergiesLupin = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else {
          this.allergiesMolluscs = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        }
      } else {
        allergies.push(allergy);
        if (allergy === "gluten") {
          this.allergiesGluten = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "crustaceans") {
          this.allergiesCrustaceans = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "eggs") {
          this.allergiesEggs = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "fish") {
          this.allergiesFish = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "peanuts") {
          this.allergiesPeanuts = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "soya") {
          this.allergiesSoya = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "milk") {
          this.allergiesMilk = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "nuts") {
          this.allergiesNuts = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "celery") {
          this.allergiesCelery = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "mustard") {
          this.allergiesMustard = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "sesame") {
          this.allergiesSesame = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "sulphites") {
          this.allergiesSulphites = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (allergy === "lupin") {
          this.allergiesLupin = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else {
          this.allergiesMolluscs = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        }
      }
      this.allergies = allergies;
    },
    selectRestriction(rest) {
      const restrictions = this.restrictions;
      if (restrictions.includes(rest)) {
        for (let i = 0; i < restrictions.length; i++) {
          if (restrictions[i] === rest) {
            restrictions.splice(i, 1);
          }
        }
        if (rest === "vegan") {
          this.restrictionsVegan = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-4"
          };
        } else if (rest === "vegetarian") {
          this.restrictionsVegetarian = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-4"
          };
        } else if (rest === "meatFreeMonday") {
          this.restrictionsMeatFreeMonday = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-4"
          };
        } else if (rest === "lactoseFree") {
          this.restrictionsLactoseFree = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-4"
          };
        } else {
          this.restrictionsGlutenFree = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-4"
          };
        }
      } else {
        restrictions.push(rest);
        if (rest === "vegan") {
          this.restrictionsVegan = {
            selected: true,
            class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-4"
          };
        } else if (rest === "vegetarian") {
          this.restrictionsVegetarian = {
            selected: true,
            class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-4"
          };
        } else if (rest === "meatFreeMonday") {
          this.restrictionsMeatFreeMonday = {
            selected: true,
            class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-4"
          };
        } else if (rest === "lactoseFree") {
          this.restrictionsLactoseFree = {
            selected: true,
            class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-4"
          };
        } else {
          this.restrictionsGlutenFree = {
            selected: true,
            class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-4"
          };
        }
      }
      this.restrictions = restrictions;
    },
    gotoNext() {
      const instance = this;
      instance.startLoading();
      const allergies = instance.allergies;
      const restrictions = instance.restrictions;
      const ref = db
        .collection("users")
        .where("userId", "==", instance.user.uid);
      ref.get().then(snapshot => {
        snapshot.forEach(doc => {
          db.collection("users")
            .doc(doc.id)
            .update({
              allergies: allergies,
              restrictions: restrictions
            })
            .then(() => {
              instance.profile.data.allergies = allergies;
              instance.profile.data.restrictions = restrictions;
              store.updateProfile(instance.profile);
              instance.isLoading = false;
              instance.$router.push({
                name: "Onboarding: Diet"
              });
            })
            .catch(error => {
              instance.isLoading = false;
              instance.notification = {
                class: "error-message p-3",
                message:
                  "Ocorreu um erro ao processar essa operação. Tente novamente."
              };
              setTimeout(() => {
                instance.clearNotification();
              }, 3000);
            });
        });
      });
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
  }
};
</script>

<style scoped>
ion-content {
  --background: var(--ion-color-primary) !important;
}
</style>
